import { ProgressiveImage } from '@/components/icons';
import useAppSelector from '@/hooks/useAppSelector';
import { getUserSelector } from '@/redux/selectors/userSelectors';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const ProgressiveInfo = styled(Grid)``;

const CompanyNameContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65px;
  min-width: 100px;
  padding: ${({ theme }) => theme.spacing(3, 0)};
  border-radius: ${({ theme }) => theme.spacing(2, 2, 0, 0)};
  background-color: #5596fc;
`;

const CompanyName = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.white};
  text-transform: uppercase;
  padding-left: ${({ theme }) => theme.spacing(4)};
  padding-right: ${({ theme }) => theme.spacing(4)};
`;

const Greetings = styled(Typography)`
  align-self: center;
  margin-left: ${({ theme }) => theme.spacing(2)};
  margin-right: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.header.info.greetings.color};
`;

const LogoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 65,
  width: 160,
  minWidth: 160,
  overflow: 'hidden',
  padding: theme.spacing(1, 1),
  borderRadius: theme.spacing(2, 2, 0, 0),
  backgroundColor: '#ffffff',
}));

const UserName = styled(Typography)`
  align-self: center;
  color: ${({ theme }) => theme.palette.common.white};
`;

const HeaderUserInfo = () => {
  const user = useAppSelector(getUserSelector);
  const companyLogo = user?.companies[0]?.logo;
  const companyName = user?.companies[0]?.name;

  return (
    <ProgressiveInfo container alignItems={'end'} wrap={'nowrap'}>
      {companyName || companyLogo ? (
        companyLogo ? (
          <LogoContainer>
            <img
              src={companyLogo}
              alt={'logo'}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </LogoContainer>
        ) : (
          <CompanyNameContainer>
            <CompanyName variant={'body1'}>{companyName}</CompanyName>
          </CompanyNameContainer>
        )
      ) : (
        <ProgressiveImage />
      )}
      <Greetings>Welcome</Greetings>
      <UserName>{user?.firstName}</UserName>
    </ProgressiveInfo>
  );
};

export default HeaderUserInfo;
